import { useEffect, useRef } from 'react';
import { useGlobalContext } from 'store/GlobalProvider';
import Splitting from 'splitting';

export function useSplitting($outerRef = null, onEnd = () => {}) {
  const { isLoaded } = useGlobalContext();
  const $innerRef = useRef(null);
  const $ref = $outerRef || $innerRef;

  useEffect(() => {
    if ($ref.current?.classList) {
      const isSplitted = $ref.current.classList.contains('splitting');

      if (isLoaded && !isSplitted) {
        Splitting({
          target: $ref.current,
          by: 'lines',
        });

        const $last = $ref.current.querySelector('.word:last-child');
        if ($last) $last.addEventListener('animationend', onEnd);

        return () => {
          $last.removeEventListener('animationend', onEnd);
        };
      }
    }
  }, [isLoaded]);

  return $ref;
}
